import { Image, PrecisionManufacturing } from "@mui/icons-material";
import { Avatar } from "@mui/material";
import { useEffect, useState } from "react";

const Thumb = (props) => {
	const [thumb, setThumb] = useState();

	useEffect(() => {
		if (props?.file?.[0]?.name) {
			let reader = new FileReader();

			reader.onloadend = () => {
				setThumb(reader.result);
			};
			reader?.readAsDataURL(props.file?.[0]);
		} else {
			if (props.file?.length === 0) {
				setThumb("");
			} else {
				setThumb(process.env.REACT_APP_STORAGE + props.file);
			}
		}
	}, [props?.file]);

	return (
		<Avatar
			variant="rounded"
			src={thumb}
			alt={props?.file?.name}
			sx={{
				width: props.small ? "50%" : "100%",
				height: props.small ? 80 : 300,
			}}
		>
			<Image style={{ fontSize: props.small ? 40 : 150 }} />
		</Avatar>
	);
};

export default Thumb;
